/**
 * LanguageToggle.js
 * EN / 日本語 switch. Persists the chosen language in localStorage
 * so it survives reloads and is picked up by i18n.js on next load.
 * Usage: <LanguageToggle />
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "../../i18n/i18n";

export default function LanguageToggle() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  };

  const btnStyle = (lng) => ({
    padding: "6px 12px",
    borderRadius: 6,
    border: "1px solid #1e293b",
    background: i18n.language === lng ? "#2563eb" : "transparent",
    color: i18n.language === lng ? "#fff" : "#94a3b8",
    fontWeight: 600,
    fontSize: "0.8rem",
    cursor: "pointer",
  });

  return (
    <div style={{ display: "inline-flex", gap: 6 }}>
      <button style={btnStyle("en")} onClick={() => changeLanguage("en")}>
        EN
      </button>
      <button style={btnStyle("ja")} onClick={() => changeLanguage("ja")}>
        日本語
      </button>
    </div>
  );
}
